import styled from "styled-components";

import { Textarea } from "../Textarea";

export const StyledAutoResizeTextarea = styled(Textarea)`
  white-space: pre-wrap;
  overflow-wrap: break-word;
  resize: none;
`;

StyledAutoResizeTextarea.displayName = "StyledAutoResizeTextarea";
